import classNames from 'classnames';
import React, { type ReactNode } from 'react';

import useScrollToTop from '@/hooks/useScrollToTop';

import Footer from '../Footer';
import { HeadPublic } from '../Head';

type LayoutProps = {
	readonly children?: ReactNode;
	readonly isButtonBack?: boolean;
};

export default function LayoutPublic({ children, isButtonBack }: LayoutProps): React.ReactElement {
	useScrollToTop();

	const layoutClassName = classNames('o-layout', 'o-layout--sm');

	return (
		<div className={layoutClassName}>
			<HeadPublic isButtonBack={isButtonBack} />
			<div className="[ o-layout__main ] [ u-scroll ]">
				<div className="o-wrapper">
					<main id="app-container">{children}</main>
					<Footer className="u-mt-24" origin='public'/>
				</div>
			</div>
		</div>
	);
}
